
import React, { useState, useEffect, useRef } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import Datepicker from "react-tailwindcss-datepicker";
import { useNavigate } from "react-router";

import {
  SlSelect,
  SlOption,
  SlIcon,
  SlDrawer,
  SlButton
} from "@shoelace-style/shoelace/dist/react";
import { format, getMonth, getYear, subMonths } from "date-fns";
import { Toast } from "../../shared/Toast";
import { CSVLink } from "react-csv";
import Paginator from "../../shared/Paginator";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { toLakhs, languageOptions, stateOptions, pricePackages, packageNewOldOptions, LocalPricePackages,BrandsTypes, slotPaymentTypeOptions } from "../../utils/constants";
import Select from 'react-select';
import api from "../../services/api";
import { formatDateDDMMYYY } from "../../utils/dateFormat";
import TableSkelton from "../../shared/TableSkelton";
import config from "../../config";

const FinanceReport = ()=>{
    const today = new Date();
    const thisMonthStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
    const thisMonthEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const formattedthisMonthStartDate = format(thisMonthStartDate, 'yyyy-MM-dd');
    const formattedthisMonthEndDate = format(thisMonthEndDate, 'yyyy-MM-dd');
    const navigate = useNavigate();
  
    const [financedata, setfinancedata] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalcount, settotalcount] = useState(0);
    const [brandtypes, setbrandtypes] = useState([5]); //alpha
    const [downloader, setDownloader] = useState(false);
    const [salesList, setsalesList] = useState([]);
    const [salesId, setsalesId] = useState(null);
    const [weeks, setweeks] = useState(null);
    const [order_new_old, setorder_new_old] = useState(null);
    const csvLinkRef = useRef();
    const [dateRange, setDateRange] = useState({ startDate: formattedthisMonthStartDate, endDate: formattedthisMonthEndDate });
    const [langfilter, setLangFilter] = useState("1");
    const [statefilter, setStatefilter] = useState(-1);
    const [districtselect, setSelectdistrict] = useState([]);
    const [districtfilter, setDistrictfilter] = useState([]);
    const [internalDetails, setInternalDetails] = useState([]);
    const [search, setSearch] = useState("");

    const [target_filter, setTarget_filter] = useState({
      lang_id: "1",
      state_id: -1,
      district_id: [],
    });
    const [openPaymentDrawer, setOpenPaymentDrawer] = useState(false);
    const [selectedPayments, setSelectedPayments] = useState([]);

    const viewPayments = (payments) => {
      setSelectedPayments(payments || []);
      setOpenPaymentDrawer(true);
    };

const handlePaymentRequestClose = () => setOpenPaymentDrawer(false);
const handlePaymentAfterHide = () => setSelectedPayments([]);

    const Headers = [
      { label: "S.No", key: "sno" },
      { label: "Month", key: "month" },
      { label: "Target", key: "target" },
      { label: "OrderName", key: "order_name" },
      { label: "Sales Person", key: "sales_person" },
      { label: "Brands", key: "brands" },
      { label: "New/Old",key:"isnew"},
      { label: "Package", key: "package" },
      { label: "Start Date", key: "start_date" },
      { label: "Order Value", key: "order_value" },
      { label: "Including GST Order Value", key:"order_value_including_gst"},
      { label: "Recieved Amount", key: "received_amount" },
      { label: "Pending Amount", key: "pending_amount" },
      { label: "Payment Details", key: "payment_details" },
    ];
    const downloadPackageAdReport = () => {
      if (financedata?.length === 0) {
        Toast("error", "No data to Download");
        return;
      }
      setDownloader(true);
      csvLinkRef?.current?.link?.click();
      setTimeout(() => {
        setDownloader(false);
      }, 3000);
    }
    const getLanguageLabel = (lang_id) => {
      const language = languageOptions.find(lang => lang.value === lang_id);
      return language ? language.label : "Unknown Language"; // Default to "Unknown Language" if not found
    };
    const defaultValue = (options, selectedValues) => {
        if (Array.isArray(selectedValues)) {
          return options?.filter(option => selectedValues.includes(option?.value));
        } else {
          return options?.find(option => option.value === selectedValues) || null;
        }
    };
    const handleDateRange = (selectedDate) => {
        if (selectedDate) {
          if (selectedDate.startDate && selectedDate.endDate) {
            setDateRange(selectedDate);
          } else {
            setDateRange({ startDate: null, endDate: null });
          }
        } else {
          setDateRange({ startDate: null, endDate: null });
        }
    }
    const LanguageFilterChange = (e) => {
        setLangFilter(e.target.value);
        setDistrictfilter([]);
        setTarget_filter({
          lang_id: e.target.value,
          state_id: -1,
          district_id: -1,
          mandal_id: -1,
          village_id: -1,
        });
        if (parseInt(e.target.value) === -1) {
          setStatefilter(-1);
          setLangFilter(-1);
          setSelectdistrict([]);
        }
    };
    
    const StateFilterChange = async (value) => {
        setStatefilter(value);
        if (parseInt(value) !== -1) {
          try {
            let res = await api({
              url: "/location/getDistrictsByStateId",
              method: "POST",
              responseType: "json",
              data: { states: [value], langs: [langfilter] },
            });
            let districts = [];
            for await (let item of res.data) {
              const temp = { value: item, label: `${item.dist_name}` };
              districts.push(temp);
            }
            setDistrictfilter(districts);
          } catch (error) {
            console.error(error);
            if (error.response.status === 401) navigate("/");
          }
        }
        if (parseInt(value) === -1) {
          setSelectdistrict([]);
          setStatefilter(-1);
        }
    };

    const DistrictFilterChanger = async (selectedOptions) => {
        if (selectedOptions && selectedOptions.length > 0) {
          const values = selectedOptions.map(option => option.value);
          setSelectdistrict(values);
        } else {
          setSelectdistrict([]);
        }
    };
    const viewInternalDetails = async(order_id) => {
        try {
          if(internalDetails && internalDetails.order_id === order_id) {
            setInternalDetails(null);
            return;
          }
          const result = await api({
            url: "/reports/packageAdReportInternalDetails",
            method: "POST",
            responseType: "json",
            data: {
              order_id: order_id
            }
          });
          if (result.code === 200) {
            setInternalDetails({order_id, list: result.data || []});
          }
        } catch (error) {
          console.error(error);
        }
    };
    const getSales = async (department_id =[]) => {
        try {
          let res = await api({
            url: "/user/sales_persons/getSalesByDepartment",
            method: "POST",
            responseType: "json",
            data: {
              dept:department_id,
            },
          });
          setsalesList(res.data);
        } catch (error) {
          console.error(error);
        }
    };
    const handleAdTypeChange = async(selectedOptions) => {
        if (!selectedOptions || selectedOptions.length === 0) {
          setbrandtypes([]);
          setsalesId(null);
          return;
        }
        const selectedDepts = selectedOptions.map(option => option.value);
        
        setbrandtypes(selectedDepts);
        setsalesId(null);
    };
    const fetchFinanceReport = async () => {
        setLoading(true)
        try {
          let res = await api({
            url: `/reports/fetchFinanceReport`,
            method: "POST",
            responseType: "json",
            data: {
              newusertypes:brandtypes,
              salesId,
              startTimestamp: dateRange.startDate,
              endTimestamp: dateRange.endDate,
              lang_id: +langfilter === -1 ? null : +langfilter,
              state_id: +statefilter === -1 ? null : +statefilter,
              district_ids: districtselect.length > 0 ? districtselect : [],
              order_new_old: order_new_old,
              search:search
            }
          })
          if (res.code == 200)
            setfinancedata(res.data);
    
        } catch (err) {
          console.log(err);
        }
        finally{
          setLoading(false)
        }
    }
    const searchData = (e) => {
      setSearch(e.target.value);
    };
    useEffect(() => {
        if(brandtypes)
        getSales(brandtypes);
    }, [brandtypes]);
    useEffect(() => {
        fetchFinanceReport();
      }, [brandtypes, salesId, dateRange, langfilter, statefilter, districtselect, order_new_old,search])
    return(
        <div>
          <div className="flex items-center gap-2 mb-4">
            <label className="text-sm font-medium">Search Order:</label>
            <input
              type="text"
              id="myInput"
              placeholder="Order Name..."
              className="px-3 py-1 border rounded-md text-sm focus:ring focus:ring-blue-300 outline-none"
              onChange={(e) => searchData(e)}
            />
          </div>
          <div className="flex space-x-4">
          <div className="w-64">
                <label className="block text-xs font-bold m-2">Brand Type</label>
                <Select
                    options={BrandsTypes}
                    value={BrandsTypes.filter(option => brandtypes.includes(option.value))}
                    onChange={handleAdTypeChange}
                    isClearable
                    isMulti
                    placeholder="Select Ad Type"
                    classNamePrefix="react-select"
                />
          </div>
            <div className="w-64">
            <label className="block text-xs font-bold m-2">SalesPersons</label>
            <Select
                aria-label="Default select example"
                placeholder="Sales Person"
                value={defaultValue(salesList, salesId)}
                onChange={(selected) => {
                if (!selected || selected.length === 0) {
                    setsalesId(null);
                } else {
                    setsalesId(selected.map((item) => item.value));
                }
                }}
                options={salesList}
                isMulti
                isClearable
            />
            </div>
            <div className="w-64">
            <label className="block text-xs font-bold m-2">New/Old</label>
            <Select
                aria-label="Default select example"
                placeholder="New/Old"
                value={defaultValue(packageNewOldOptions, order_new_old)}
                onChange={(selected) => {
                setorder_new_old(selected ? selected.value : null);
                }}
                options={packageNewOldOptions}
                isClearable
            />
            </div>
            <div>
            <label className="block text-xs font-bold m-2">Date Range</label>
            <div className="border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66">
                <Datepicker
                classNames="form-input"
                value={dateRange}
                primaryColor={"cyan"}
                showShortcuts={true}
                useRange={true} // Allow date range selection
                configs={{
                    shortcuts: {
                    today: "today",
                    yesterday: "yesterday",
                    currentMonth: "currentMonth",
                    pastMonth: "lastMonth",
                    },
                }}
                onChange={handleDateRange}
                />
            </div>
            </div>
            <div className="w-64">
            <label className="block text-xs font-bold m-2">Language</label>
            <SlSelect
                placeholder="Select Language"
                name="lang"
                size="medium"
                onSlChange={LanguageFilterChange}
                value={langfilter}
            >
                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                {languageOptions.map((item) => {
                return (
                    <SlOption key={item.value} value={item.value}>
                    {item.label}
                    </SlOption>
                );
                })}
            </SlSelect>
            </div>
            {langfilter !== -1 && (
            <div className="w-64">
                <label className="block text-xs font-bold m-2">State</label>
                <SlSelect
                placeholder="Select State"
                name="state"
                size="medium"
                onSlChange={(e) => {
                    StateFilterChange(e.target.value);
                }}
                >
                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                <SlOption value="-1">All</SlOption>
                {stateOptions
                    .filter((item) => item.lang_id === +langfilter)
                    .map((item) => {
                    return (
                        <SlOption key={item.state_id} value={item.state_id}>
                        {item.state_name}
                        </SlOption>
                    );
                    })}
                </SlSelect>
            </div>
            )}

            {statefilter !== -1 && (
            <div className="w-64">
                <label className="block text-xs font-bold m-2">District</label>
                <Select
                placeholder="Select Districts"
                name="district"
                isMulti={true}
                isClearable={true}
                options={districtfilter.map((item) => ({
                    value: item.value.dist_id,
                    label: item.label,
                }))}
                onChange={DistrictFilterChanger}
                classNamePrefix="react-select"
                />
            </div>
            )}
            <div className="">
            <label className="block text-xs font-bold m-2">Download</label>
            <sl-tooltip content="Download" hoist>
                <sl-icon-button
                library="lucide"
                name="download"
                onClick={() => {
                    downloadPackageAdReport();
                }}
                className="top-4 right-4"
                ></sl-icon-button>
            </sl-tooltip>
            <CSVLink
              data={[
                ...financedata.map((row, idx) => ({
                  sno: idx + 1,
                  month: new Date(row?.o_start_date * 1000).toLocaleString("default",{ month: "long" }),

                  target: [
                    row?.lang_ids?.length > 0 && `Languages: ${row.lang_ids.map(id => getLanguageLabel(id)).join(", ")}`,
                    row?.state_ids?.length > 0 && `States: ${row.state_ids.map(s => s.state_name).join(", ")}`,
                    row?.district_ids?.length > 0 && `Districts: ${row.district_ids.map(d => d.dist_name).join(", ")}`,
                    row?.constituency_ids?.length > 0 && `Constituencies : ${row.constituency_ids.map(c => c.const_name).join(", ")}`,
                    row?.mandal_ids?.length > 0 && `Mandals : ${row.mandal_ids.map(m => m.mandal_name).join(", ")}`,
                    row?.village_ids?.length > 0 && `Villages : ${row.village_ids.map(v => v.village).join(", ")}`
                  ].filter(Boolean).join(" \n ") || "No Location",

                  order_name: row?.order_name,
                  sales_person: row?.sales_person_name,
                  brands: row.brands?.length ? row.brands.join("\n") : "-",
                  isnew:row?.isnew ? `NEW` : `OLD`,
                  package: row?.ispackage === 1 ? "TRUE" : "FALSE",
                  start_date: formatDateDDMMYYY(row?.o_start_date),
                  order_value: row?.order_value,
                  order_value_including_gst:(Number(row?.order_value || 0) * 1.18).toFixed(2),
                  received_amount: row?.total_paid,

                  pending_amount:
                  (Number(row?.order_value || 0) * 1.18).toFixed(2) - row?.total_paid > 0
                      ? ((Number(row?.order_value || 0) * 1.18).toFixed(2) - row?.total_paid).toFixed(2)
                      : 0,

                  payment_details: row?.payment_details?.length
                    ? row.payment_details.map(p =>
                        `{${Object.entries(p).map(([k, v]) =>`${k}: ${v}`).join(", ")}}`
                      ).join(" | ")
                    : "{}",
                })),

                // -------- Grand Total Row ----------
                {
                  sno: "",
                  month: "",
                  target: "",
                  order_name: "",
                  sales_person: "",
                  brands: "",
                  isnew:"",
                  package: "Grand Total",
                  start_date: "",

                  order_value: financedata.reduce((sum,r)=>sum + Number(r?.order_value||0),0).toFixed(2),
                  order_value_including_gst:financedata.reduce((sum,r)=>Math.round(Number(r?.order_value || 0) * 1.18),0).toFixed(2),
                  received_amount: financedata.reduce((sum,r)=>sum + Number(r?.total_paid||0),0).toFixed(2),
                  pending_amount: financedata.reduce((sum,r)=>{
                    const diff = Math.round(Number(r?.order_value||0)*1.18) - +r?.total_paid;
                    return sum + (diff > 0 ? diff : 0)
                  },0).toFixed(2),
                  payment_details: "",
                }
              ]}
              headers={Headers}
              filename="FinanceReport.csv"
              ref={csvLinkRef}
              style={{ display: "none" }}
            />
            </div>
          </div>
          <ScrollContainer>
            <table className="table table-bordered mt-4">
                <thead>
                    <tr className="bg-gray-100">
                    <th>S.No</th>
                    <th>Month</th>
                    <th>Target</th>
                    <th>OrderName</th>
                    <th>Sales Person</th>
                    <th>Brands</th>
                    <th>New/Old</th>
                    <th>Package</th>
                    <th>Start Date</th>
                    <th>Order Value</th>
                    <th>Order Value Including GST</th>
                    <th>Recieved Amount</th>
                    <th>Pending Amount</th>
                    <th>Payment Details</th>
                    </tr>
                </thead>

                {financedata && financedata.length > 0 ? (
                    <tbody>
                    {financedata.map((row, idx) => (
                        <>
                            <tr
                                key={idx}
                                className="border-t"
                                onClick={() => {
                                    viewInternalDetails(row.order_id);
                                }}                            
                             >
                            <td>{idx + 1}</td>
                            <td>
                                {new Date(row?.o_start_date * 1000).toLocaleString(
                                  "default",
                                  { month: "long" }
                                )}
                            </td>
                            <td className="max-w-[200px] truncate whitespace-nowrap overflow-hidden"
                                    title=  {[
                                        row.lang_ids?.length > 0 && `Languages: ${row.lang_ids.map(id => getLanguageLabel(id)).join(", ")}`,
                                        row.state_ids?.length > 0 && `States: ${row.state_ids.map(s => s.state_name).join(", ")}`,
                                        row.district_ids?.length > 0 && `Districts: ${row.district_ids.map(d => d.dist_name).join(", ")}`,
                                        row.constituency_ids?.length > 0 && `Constituencies: ${row.constituency_ids.map(c => c.const_name).join(", ")}`,
                                        row.mandal_ids?.length > 0 && `Mandals: ${row.mandal_ids.map(m => m.mandal_name).join(", ")}`,
                                        row.village_ids?.length > 0 && `Villages: ${row.village_ids.map(v => v.village).join(", ")}`,
                                  ].filter(Boolean).join(" \n ")}
                            >
                              {row.lang_ids?.length > 0 && `Languages: ${row.lang_ids.map(id => getLanguageLabel(id)).join(", ")}, `}
                              {row.state_ids?.length > 0 && `States: ${row.state_ids.map(s => s.state_name).join(", ")}, `}
                              {row.district_ids?.length > 0 && `Districts: ${row.district_ids.map(d => d.dist_name).join(", ")}, `}
                              {row.constituency_ids?.length > 0 && `Constituencies: ${row.constituency_ids.map(c => c.const_name).join(", ")}, `}
                              {row.mandal_ids?.length > 0 && `Mandals: ${row.mandal_ids.map(m => m.mandal_name).join(", ")}, `}
                              {row.village_ids?.length > 0 && `Villages: ${row.village_ids.map(v => v.village).join(", ")}, `}
                            </td>
                            <td>{row?.order_name}</td>
                            <td>{row?.sales_person_name}</td>
                            <td>
                              {Array.isArray(row.brands) && row.brands.length > 0 ? (
                                <div>{row.brands.join(", ")}</div>
                              ) : '-'}
                            </td>
                            <td>{row.isnew ? `NEW` :`OLD`}</td>
                            <td>{row?.ispackage === 1 ? `TRUE` : `FALSE`}</td>
                            <td>{formatDateDDMMYYY(row?.o_start_date)}</td>
                            <td>{row?.order_value}</td>
                            <td>{Math.round(Number(row?.order_value || 0) * 1.18)}</td>
                            <td>{row?.total_paid}</td>
                            <td>{Math.round((Number(row?.order_value || 0) * 1.18) - row?.total_paid > 0) ? Math.round((Number(row?.order_value || 0) * 1.18)- row?.total_paid) : 0}</td>
                            <td>
                                <SlButton 
                                  variant="primary"
                                  size="small"
                                  className="px-3 py-1"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    viewPayments(row.payment_details);
                                  }}
                                >
                                  View Payments
                                </SlButton>
                              </td>
                            </tr>
                            {internalDetails && internalDetails.order_id === row.order_id && (
                            <tr>
                              <td colSpan={17} className="p-4">
                                <div className="flex justify-center">
                                  <div className="border rounded-xl shadow-sm bg-white p-4 w-[80%] relative">
                                    <button
                                        onClick={() => setInternalDetails([])}
                                        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                                      >
                                        ✕
                                      </button>
                                    <h3 className="text-lg font-semibold mb-3 text-gray-700 text-center">
                                      Campaign Details
                                    </h3>

                                    <table className="w-full border-collapse">
                                      <thead>
                                        <tr style={{ backgroundColor: "#dbeafe" }}>
                                          {" "}
                                          {/* Change theme here */}
                                          <th
                                            style={{
                                              padding: "8px",
                                              border: "1px solid #bfdbfe",
                                              textAlign: "left",
                                            }}
                                          >
                                            S.No
                                          </th>
                                          <th
                                            style={{
                                              padding: "8px",
                                              border: "1px solid #bfdbfe",
                                              textAlign: "left",
                                            }}
                                          >
                                            Campaign Name
                                          </th>
                                          <th
                                            style={{
                                              padding: "8px",
                                              border: "1px solid #bfdbfe",
                                              textAlign: "left",
                                            }}
                                          >
                                            Start Date
                                          </th>
                                          <th
                                            style={{
                                              padding: "8px",
                                              border: "1px solid #bfdbfe",
                                              textAlign: "left",
                                            }}
                                          >
                                            End Date
                                          </th>
                                          <th
                                            style={{
                                              padding: "8px",
                                              border: "1px solid #bfdbfe",
                                              textAlign: "left",
                                            }}
                                          >
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {internalDetails.list.length > 0 ? (
                                          internalDetails.list.map((item, idx) => (
                                            <tr
                                              key={idx}
                                              style={{
                                                backgroundColor:
                                                  idx % 2 === 0 ? "#ffffff" : "#eff6ff",
                                                transition: "0.2s",
                                              }}
                                            >
                                              <td
                                                style={{
                                                  border: "1px solid #bfdbfe",
                                                  padding: "8px",
                                                }}
                                              >
                                                {idx + 1}
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid #bfdbfe",
                                                  padding: "8px",
                                                }}
                                              >
                                                {item.campaign_name}
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid #bfdbfe",
                                                  padding: "8px",
                                                }}
                                              >
                                                {formatDateDDMMYYY(item.start_date)}
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid #bfdbfe",
                                                  padding: "8px",
                                                }}
                                              >
                                                {formatDateDDMMYYY(item.end_date)}
                                              </td>
                                              <td
                                                style={{
                                                  border: "1px solid #bfdbfe",
                                                  padding: "8px",
                                                }}
                                              >
                                                {item.cpd}
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td
                                              className="border p-3 text-center text-gray-500"
                                              colSpan={5}
                                            >
                                              No data found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </td>
                            </tr>
                    )}
                        </>
                    ))}
                    <tr className="bg-blue-100 font-bold text-lg">
                        <td colSpan={9} className="text-center font-bold">Grand Total</td>

                        {/* Total Order Value */}
                        <td>
                            {financedata.reduce(
                                (sum, row) => sum + Number(row?.order_value || 0),
                                0
                            ).toFixed(2)}
                        </td>
                        <td>
                            {financedata.reduce(
                                (sum, row) => sum + (+(Number(row?.order_value || 0) * 1.18).toFixed(2)),
                                0
                            ).toFixed(2)}
                        </td>
                        {/* Total Received */}
                        <td>
                            {financedata.reduce(
                                (sum, row) => sum + Number(row?.total_paid || 0),
                                0
                            ).toFixed(2)}
                        </td>
                        {/* Pending Amount */}
                        <td>
                            {financedata.reduce(
                                (sum, row) =>
                                    sum + +((Number(row?.order_value || 0) * 1.18).toFixed(2) - Number(row?.total_paid || 0)).toFixed(2),
                                0
                            ).toFixed(2)}
                        </td>
                        <td></td>
                    </tr>
                    </tbody>
                ) : !financedata?.length && !loading ? (
                    <NoDataFound colspan="14" />
                ) : (
                    <TableSkelton colspan="14" />
                )}
            </table>
          </ScrollContainer>
          <SlDrawer 
              label="Payment Details"
              open={openPaymentDrawer}
              onSlRequestClose={() => setOpenPaymentDrawer(false)}
              onSlAfterHide={() => setSelectedPayments([])}
              style={{ "--size": "450px" }}
            >
              <div className="p-4 space-y-4">
                {selectedPayments?.length ? (
                  <>
                    {selectedPayments.map((payment, index) => (
                      <div 
                        key={index} 
                        className="border border-gray-300 bg-gray-100 rounded-lg p-4 shadow-sm"
                      >
                        <h3 className="font-bold text-blue-600 mb-3 text-lg">
                          Payment #{index + 1}
                        </h3>

                        {Object.entries(payment).map(([key, value]) => {
                          const label = key.replace(/_/g," ").replace(/\b\w/g,l=>l.toUpperCase());
                          const finalValue =
                            key.includes("date") && typeof value === "number"
                              ? formatDateDDMMYYY(value)
                              : key.includes("amount")
                              ? `₹${value}`
                              : key === 'payment_type' ? 
                              slotPaymentTypeOptions.find(item => +item.value === +value)?.label || value :
                              value;

                          return (
                            <p key={key} className="text-sm mb-1">
                              <span className="font-semibold">{label}:</span> {finalValue || '-'}
                            </p>
                          );
                        })}
                      </div>
                    ))}

                    {/* TOTAL SUMMARY */}
                    <div className="bg-blue-100 p-4 rounded-md font-semibold text-lg border border-blue-300">
                      Total Paid: ₹{
                        selectedPayments.reduce((sum,p)=> sum + Number(p.amount || 0), 0)
                      }
                    </div>
                  </>
                ) : (
                  <p className="text-center text-gray-500 py-6">No Payment Details Found</p>
                )}
              </div>

              <SlButton slot="footer" variant="danger" className="mt-2" onClick={() => setOpenPaymentDrawer(false)}>
                Close
              </SlButton>
          </SlDrawer>

        </div>
    )
}
export default FinanceReport;